export const ATTORNEY_NAME = "attorney_name";
export const CASE = "case";
export const CR_REG_NUMBER = "cr_reg_number";
export const EVENT = "event_group";
export const EVENT_ACTION = "event_group_action";
export const EVENT_AND = "event_group_and";
export const EVENT_CAUSE = "event_group_cause";
export const EVENT_ISSUE = "event_group_issue";
export const EVENT_RESULT = "event_group_result";
export const FILING_TEXT = "filing_text";
export const FIRM_COMPARISON = "firm_comparison";
export const FIRM_NAME = "firm_name";
export const PARTY_NAME = "party_name";
export const PARTY_NAME_AND = "party_name_and";
export const TERM_DEFINITION = "term_definition";
export const TERM_NAME = "term_name";
export const TM_REG_NUMBER = "tm_reg_number";
export const TM_SER_NUMBER = "tm_ser_number";

// NOTE: Incomplete list. Only including criteria for which the client has special behavior
